import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "grid align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "col-3"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-9" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Telegram", -1)
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Skype", -1)
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.$t('manager')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.user.avatar_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "w-full border-circle",
              src: _ctx.user.avatar_url
            }, null, 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.user.firstname) + " " + _toDisplayString(_ctx.user.lastname), 1),
        (_ctx.user.telegram)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("a", {
                href: `https://t.me/${_ctx.user.telegram}`,
                target: "_blank"
              }, _toDisplayString(_ctx.user.telegram), 9, _hoisted_11)
            ]))
          : _createCommentVNode("", true),
        (_ctx.user.skype)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("a", {
                href: `skype:${_ctx.user.skype}?chat`,
                target: "_blank"
              }, _toDisplayString(_ctx.user.skype), 9, _hoisted_14)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}